/** Permission required to approve or reject a space reservation request (backend source of truth). */
export var BOOKING_APPROVAL_PERMISSION = 'spaces:approve_reservations';
/** `object_type` for permitted checks scoped to a space. */
export var PERMITTED_OBJECT_TYPE_SPACE = 'space';
